// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-primary-really-fancy[data-v-3dca6466]{background:linear-gradient(-45deg,#13afb6,#03659c 50%,#b6f2f5)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
